export const ContestQuestionType = {
    SINGLE_CHOICE: 'single_choice',
    MULTIPLE_CHOICE: 'multiple_choice',
    TEXT: 'text',
} as const;
export type ContestQuestionTypeTypes = typeof ContestQuestionType[keyof typeof ContestQuestionType];